// src/lib/supabase.ts
// Supabase browser client singleton — uses @supabase/supabase-js directly
// (no @supabase/ssr adapter). Auth tokens stored in localStorage by the
// Supabase JS client automatically.

import { createClient } from '@supabase/supabase-js'
import { clientEnv } from '@/src/env'

/**
 * Browser-side Supabase client singleton.
 *
 * Uses the anon key and respects RLS policies.
 * Auth state managed via localStorage (Supabase JS default).
 */
export const supabase = createClient(
  clientEnv.VITE_SUPABASE_URL,
  clientEnv.VITE_SUPABASE_ANON_KEY,
)
